/** Checkout de Shopify: todos los botones de compra apuntan aquí. */
export const CHECKOUT_URL = 'https://jseefect.com/cart/47063066738887:1'

export const pains = [
  {
    title: '¿Te da pena que te miren?',
    body: 'Entras, sientes que todos voltean, y terminas caminando 20 minutos en la caminadora solo porque es lo único que sabes usar.',
  },
  {
    title: '¿No sabes usar las máquinas?',
    body: 'Los aparatos no tienen instrucciones en español. Tienes miedo de ponerle mal el peso, de lastimarte o de hacer el ridículo.',
  },
  {
    title: '¿Crees que todos te juzgan?',
    body: 'Preferirías no ir antes que preguntar. Y así pasan los meses pagando una membresía que casi no usas.',
  },
]

export const benefits = [
  {
    title: 'Rutina exacta de 30 días',
    body: 'Día por día: qué máquina usar, cuántas series, cuántas repeticiones y cuánto descansar. Sin improvisar.',
  },
  {
    title: 'Diccionario inglés → español del gym',
    body: 'Traducción de cada máquina, letrero y ejercicio para que entiendas todo lo que ves y escuchas dentro.',
  },
  {
    title: 'Guía de alimentación en USA',
    body: 'Qué comprar en Walmart, Target o la tienda latina. Comida real, barata y con proteína suficiente.',
  },
  {
    title: 'Checklist de mochila',
    body: 'Exactamente qué llevar tu primer día para entrar seguro y salir sin dar explicaciones a nadie.',
  },
]

export const faqs = [
  {
    q: '¿Es seguro el pago?',
    a: 'Sí. El pago se procesa con cifrado SSL de 256 bits a través de una pasarela certificada (Stripe / PayPal). Nosotros nunca vemos ni guardamos los datos de tu tarjeta.',
  },
  {
    q: '¿Recibo el acceso inmediato?',
    a: 'Sí. En cuanto se aprueba el pago recibes el eBook en tu correo en formato PDF, listo para leer en el celular o imprimir. No hay que esperar envíos.',
  },
  {
    q: '¿Sirve si no sé nada de inglés?',
    a: 'Para eso lo hicimos. Todo está en español y además incluye el diccionario con la traducción de cada máquina y letrero del gimnasio.',
  },
  {
    q: '¿Sirve si nunca he entrenado en mi vida?',
    a: 'Es literalmente para eso. La guía asume que hoy es tu primer día y te lleva de la mano las primeras 4 semanas.',
  },
  {
    q: '¿Y si no me gusta?',
    a: 'Tienes 7 días de garantía. Escribes un correo, te devolvemos los $7 completos y te quedas con el eBook.',
  },
]
